import React from "react";
import { DotMarker } from "../../../common-components";

const CardDisplay = ({
  marker1,
  marker2,
  marker3,
  marker4,
  marker5,
  marker6,
  width,
  onOneClick,
  onTwoClick,
  onThreeClick,
  onFourClick,
  onFiveClick,
  onSixClick,
}) => {
  return (
    <div
      style={{
        width: "100%",
        position: "absolute",
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: width > 599 ? 40 : 20,
      }}
    >
      <DotMarker selected={marker1} onClick={onOneClick} />
      <div style={{ width: 7 }} />
      <DotMarker selected={marker2} onClick={onTwoClick} />
      <div style={{ width: 7 }} />
      <DotMarker selected={marker3} onClick={onThreeClick} />
      <div style={{ width: 7 }} />
      <DotMarker selected={marker4} onClick={onFourClick} />
      <div style={{ width: 7 }} />
      <DotMarker selected={marker5} onClick={onFiveClick} />
      {/* <div style={{ width: 7 }} />
      <DotMarker selected={marker6} onClick={onSixClick} /> */}
    </div>
  );
};

export default CardDisplay;
